import React from 'react';
import { BarChart3, Database, PieChart, Brain, Activity, Gauge, FileBarChart } from 'lucide-react';
import { ServicePage } from '../components/ServicePage';
export function DataAnalytics() {
  return <ServicePage badgeText="DATA ANALYTICS" badgeIcon={<BarChart3 className="w-3.5 h-3.5" data-id="element-366" />} titleStart="Decisions powered by" titleAccent="real data" titleAccentColor="amber" subtitle="Turn raw data into clear, actionable insight. We build data pipelines, dashboards, and ML models that put truth at the center of every decision." heroIcon={BarChart3} heroIconColor="text-amber-600" heroIconBg="bg-amber-50" checklist={['Modern data stack setup', 'Self-serve dashboards', 'Predictive ML models', 'Real-time analytics']} features={[{
    title: 'Data Engineering',
    description: 'Robust pipelines and warehousing on Snowflake, BigQuery, or Postgres — your choice.',
    icon: Database
  }, {
    title: 'Business Intelligence',
    description: 'Beautiful dashboards in Metabase, Looker, or Tableau that your team will actually use.',
    icon: PieChart
  }, {
    title: 'Predictive Modeling',
    description: 'Forecasting, churn prediction, and recommendation engines tailored to your business.',
    icon: Brain
  }, {
    title: 'Real-time Analytics',
    description: 'Streaming pipelines that surface insights the moment your data is generated.',
    icon: Activity
  }, {
    title: 'KPI Frameworks',
    description: 'North-star metrics and reporting cadences that align your whole organization.',
    icon: Gauge
  }, {
    title: 'Custom Reporting',
    description: 'Executive reports and investor decks generated automatically from live data.',
    icon: FileBarChart
  }]} processSteps={[{
    number: '01',
    title: 'Assess',
    description: 'Audit your current data sources, tools, and analytics maturity.'
  }, {
    number: '02',
    title: 'Architect',
    description: 'Design a modern data stack tailored to your scale and team.'
  }, {
    number: '03',
    title: 'Build',
    description: 'Implement pipelines, models, and dashboards iteratively.'
  }, {
    number: '04',
    title: 'Enable',
    description: 'Train your team and hand over a self-serve analytics culture.'
  }]} ctaTitle="Ready to be a data-driven business?" ctaSubtitle="Let's turn your data into your competitive advantage." data-id="element-365" />;
}